import { string } from "yup";
import {
  TIME_PLACEHOLDER_HOURS_MINUTES,
  TIME_REGEX_HOURS_MINUTES,
} from "./Constants/TimeConstants";

export const yupTimesValidation = <T>(path: keyof T) =>
  string()
    .optional()
    .test({
      name: path.toString(),
      message: `${path.toString()} should be in format ${TIME_PLACEHOLDER_HOURS_MINUTES}.`,
      test: (value) => {
        return value === undefined || value === ""
          ? true
          : value.match(TIME_REGEX_HOURS_MINUTES) !== null;
      },
    });
